import IfFeature from 'view-components/components/Containers/IfFeature';

/* eslint-disable no-underscore-dangle */
IfFeature.featureData = () => window.__FEATURES__;
/* eslint-enable no-underscore-dangle */

export default IfFeature;
